import { AlertConfigurations } from '@/utils/alerts.utilities.js'
const alertStrategies = {
  modal: {
    success:  AlertConfigurations.successAlert,
    error:  AlertConfigurations.failedAlert,
    cleanup: AlertConfigurations.closeAlert
  },
  toast: {
    success: (message, title) => AlertConfigurations.toastNotification(message, title, 'success'),
    error: (message, title) => AlertConfigurations.toastNotification(message, title, 'error'),
    cleanup: () => {}
  },
  none: {
    success: () => {},
    error: () => {},
    cleanup: () => {}
  }
};

export function processResponse(responseData, isShowAlert = false, alertConfig = {}) {
   const alertType = alertConfig.type || 'modal';
   const alertStrategy = alertStrategies[alertType] || alertStrategies.none;
   try {
     if (responseData && responseData.responseCode === 200) {
      if (isShowAlert) {
        const message = alertConfig.message || responseData.responseStatus || 'Operation completed successfully!';
        const title = alertConfig.title || 'Success';
        alertStrategy.success(message, title);
      }
      return true;
    } else {
        const errorMessage = responseData.data || 'An unknown error occurred.';
      console.error("API Logic Error:", errorMessage);
      if (isShowAlert) {
        const message = alertConfig.message || errorMessage;
        const title = alertConfig.title || 'Operation Failed';
        alertStrategy.error(responseData.data, title);
      }
      return false;
    }
  } catch (error) {
     console.error("An error occurred while processing the response:", error);
    if (isShowAlert) {
      const message = 'A client-side error occurred. Please check the console for details.';
      const title = 'Processing Error';
      alertStrategy.error(message, title);
    }
    return false;
  } finally {
  }
}
